<template>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="jumbotron text-center" style="background-color: #fff">
            <img  src="../assets/img/logo_IASO.png" alt="Iaso-digital" width="15%" style="margin-bottom:15px; margin-top:5px;">
            <p>Bienvenue sur la plateforme d'enregistrement des voix de personnages de Iaso Digital !</p>
            <p style="margin-bottom:5px;font-size:16px">Cette plateforme web permet d'afficher les textes des personnages (avatars 3D), qui vous ont été attribués, et que vous devez jouer, et vous permet de vous enregistrer en ligne.</p>
            <p style="margin-bottom:5px;font-size:16px;">Iaso Digital récupère, alors, automatiquement les fichiers des voix enregistrées et vous n'avez plus rien à faire !</p>
            <p style="margin-bottom:0px;font-size:16px;">Veuillez s'il-vous-plaît entrer ci-dessous votre adresse email et créer votre mot de passe, afin de vous connecter à notre plateforme d'enregistrement des voix de personnages.</p>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-md-offset-4 col-md-4">
              <div class="form-login" @keyup.enter="validate()">
                  <h4>Enregistrement de votre compte</h4>
                  <input type="text" v-model.trim="updateInfo.firstname" class="form-control input-sm chat-input" placeholder="Prénom (optionnel)" />
                  <br>
                  <input type="text" v-model.trim="updateInfo.lastname" class="form-control input-sm chat-input" placeholder="Nom (optionnel)" />
                  <br>
                  <input type="password" v-model="updateInfo.password" class="form-control input-sm chat-input" placeholder="Mot de passe (min. 6 caractères)" />
                  <br>
                  <div class="wrapper">
                      <span class="group-btn">
                          <button @click="validate()" class="btn btn-primary btn-md">Valider</button>
                      </span>
                  </div>
                  <div class="text-center" style="color:red;margin-top:2%;" v-if="passwordTooShort">
                      Votre mot de passe doit comporter 6 caractères minimum.
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        components: {
        },
        computed: {
        },
        methods: {
            validate() {
                if (this.updateInfo.password.length < 6)   {
                    this.passwordTooShort = true;
                    return;
                }

                let callback = () => {
                    this.$router.push({ name: 'Connection' });
                };

                this.$store.dispatch('userFirstUpdate', {   userId: this.$route.params.userId,
                                                            updateInfo: this.updateInfo,
                                                            callbacks: { success: callback,
                                                                         fail: callback,
                                                                         error: callback
                                                                      }
                                                        });
            }
        },
        data: function()  {
            return {
                updateInfo: {
                    firstname: "",
                    lastname: "",
                    password: ""
                },
                passwordTooShort: false
            };
        }
    };
</script>

<style scoped>
    .login {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 50%;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

    @import url(https://fonts.googleapis.com/css?family=Roboto:400);
    body {
        background-color:#fff;
        -webkit-font-smoothing: antialiased;
        font: normal 14px Roboto,arial,sans-serif;
    }

    .form-login {
        background-color: #EDEDED;
        padding-top: 10px;
        padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 15px;
        border-color:#d2d2d2;
        border-width: 5px;
        box-shadow:0 1px 0 #cfcfcf;
    }

    h4 {
        border:0 solid #fff;
        border-bottom-width:1px;
        padding-bottom:10px;
        text-align: center;
    }

    .form-control {
        border-radius: 10px;
    }

    .wrapper {
        text-align: center;
    }


</style>
